import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const AnonymousHeaderBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AnonymousHeaderBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shortLink"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shortLink"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CurrentBoardFull"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"AnonymousHeaderBoard","document":AnonymousHeaderBoardDocument}} as const;
export type AnonymousHeaderBoardQueryVariables = Types.Exact<{
  shortLink: Types.Scalars['ID'];
}>;


export type AnonymousHeaderBoardQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id' | 'idOrganization'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Types.Member, 'id' | 'memberType'>
    )> }
  )> }
);




/**
 * __useAnonymousHeaderBoardQuery__
 *
 * To run a query within a React component, call `useAnonymousHeaderBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnonymousHeaderBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnonymousHeaderBoardQuery({
 *   variables: {
 *      shortLink: // value for 'shortLink'
 *   },
 * });
 */
export function useAnonymousHeaderBoardQuery(baseOptions: Apollo.QueryHookOptions<AnonymousHeaderBoardQuery, AnonymousHeaderBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnonymousHeaderBoardQuery, AnonymousHeaderBoardQueryVariables>(AnonymousHeaderBoardDocument, options);
      }
export function useAnonymousHeaderBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnonymousHeaderBoardQuery, AnonymousHeaderBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnonymousHeaderBoardQuery, AnonymousHeaderBoardQueryVariables>(AnonymousHeaderBoardDocument, options);
        }
export type AnonymousHeaderBoardQueryHookResult = ReturnType<typeof useAnonymousHeaderBoardQuery>;
export type AnonymousHeaderBoardLazyQueryHookResult = ReturnType<typeof useAnonymousHeaderBoardLazyQuery>;
export type AnonymousHeaderBoardQueryResult = Apollo.QueryResult<AnonymousHeaderBoardQuery, AnonymousHeaderBoardQueryVariables>;